<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <b-row class="desktop">
            <b-col cols="3">
                <RecipeSidebar class="mt-5" manage='active' />
            </b-col>
            <b-col cols="9">
                <b-row class="head-box mb-4">
                    <b-col cols="4" class="">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="0.99" icon="calendar2-date"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" placeholder="Recipe Name "></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="4" class="">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="0.99" icon="globe"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" placeholder="Origin "></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="4" class="btn-box">
                        <button class="btn btn-warning btn-culture">
                            <b-icon font-scale="0.99" icon="search"></b-icon>Search
                        </button>
                    </b-col>
                </b-row>
                <div class="mt-4" v-if="loading">
                    <content-loader :speed="2" :height="400" :width="600">
                        <circle cx="25" cy="112" r="15" />
                        <rect x="10" y="18" rx="0" ry="0" width="464" height="9" />
                        <rect x="497" y="10" rx="0" ry="0" width="144" height="144" />
                        <rect x="10" y="41" rx="0" ry="0" width="464" height="9" />
                        <rect x="10" y="65" rx="0" ry="0" width="364" height="9" />
                        <rect x="50" y="98" rx="0" ry="0" width="115" height="9" />
                        <rect x="50" y="115" rx="0" ry="0" width="115" height="10" />
                    </content-loader>
                </div>
                <p class="mt-4 d-flex justify-content-between" v-if="!loading">
                    <span>
                        Per page:
                        <select class="" v-model="no_per_page" @change="getChefRequests(page)">
                            <option value="10" selected>10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select> items
                    </span>
                    <span>{{page}} of {{rows}} Approvals</span>
                </p>
                <b-row class="top-box text-center">
                    <b-col cols="4" @click="showApprovals" :class="isApprovals == true ? 'active':''" class="inner-header-box">
                        <b-icon icon="envelope"></b-icon> View Approvals
                    </b-col>
                    <b-col cols="4" @click="showRequests" :class="isRequests == true ? 'active':''" class="inner-header-box">
                        <b-icon icon="heart"></b-icon> View My Requests
                    </b-col>
                </b-row>
                <div v-if="isApprovals">
                    <ApprovalCard v-for="(req,index) in chefApprovals" :key="index+req" :location="req.guest_address" :startDate="convert_date(req.proposed_start)" :endDate="convert_date(req.proposed_end)" details_route_name="recipe-details" :user_id="req.guest.user_id" :routeId="req.recipe.food_id" user_route_name="public-profile" @handleMessage="showGuestMessage(req)" :message="req.guest_rejection_reason" :isHost="true" :Approval="true" :Reject="true" @handleReject="handleRejectHire(req)" @handleApproval="handleApproveHire(req)" class="mt-2 mb-4" :imgUrl="req.recipe.images" :listName="req.recipe.name" :listDesc="req.recipe.storyline" :dateTime="req.created_at" :hostName="req.guest.first_name" :status="req.status" :actionDate="req.updated_at" />
                </div>
                <div v-if="isRequests">
                    <RequestCard v-for="(req, index) in guestRequests" :key="index+req" details_route_name="recipe-details" :user_id="req.chef.user_id" :needPayment="checkforPayment(req)" :routeId="req.recipe.food_id" user_route_name="public-profile" class="mt-2 mb-4" :imgUrl="req.recipe.images" :listName="req.recipe.name" @handleMessage="showChefMessage(req)" :message="req.chef_rejection_reason" :listDesc="req.recipe.storyline" @handleReject="guestReject(req)" torouteName='chef-pay' :dateTime="req.created_at" :hostName="req.chef.first_name" :status="req.status" :amount="req.amount" :currency="req.currency" :bookingId="req.hire_id" />
                </div>
                <div v-if="chefApprovals.length >0">
                    <b-pagination v-model="page" :total-rows="rows" @change="getChefRequests" :per-page="no_per_page">
                    </b-pagination>
                </div>
            </b-col>
        </b-row>

        <div class="mobile">
            <b-row>
                <b-col cols="3">
                    <RecipeSidebar class="mt-5" manage='active' />
                </b-col>
                <b-col cols="9">
                    <b-row class="head-box mb-4">
                        <b-col cols="12" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="calendar2-date"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="Recipe Name "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="globe"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="Origin "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" class="btn-box">
                            <button class="btn btn-warning btn-culture">
                                <b-icon font-scale="0.99" icon="search"></b-icon>Search
                            </button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <p> {{chefApprovals.length}} Requests</p>
            <b-row class="top-box text-center">
                <b-col cols="6" @click="showApprovals" :class="isApprovals == true ? 'active':''" class="inner-header-box">
                    <b-icon icon="envelope"></b-icon> Listing Approvals
                </b-col>
                <b-col cols="6" @click="showRequests" :class="isRequests == true ? 'active':''" class="inner-header-box">
                    <b-icon icon="heart"></b-icon> Listing Requests
                </b-col>

            </b-row>
            <div v-if="isApprovals">
                <ApprovalCard v-for="(req,index) in chefApprovals" :key="index" :location="req.guest_address" :startDate="convert_date(req.proposed_start)" :endDate="convert_date(req.proposed_end)" details_route_name="recipe-details" :user_id="req.guest.user_id" :routeId="req.recipe.food_id" user_route_name="public-profile" :Approval="true" :Reject="true" @handleReject="handleRejectHire(req)" @handleApproval="handleApproveHire(req)" class="mt-2 mb-4" :imgUrl="req.recipe.images" :listName="req.recipe.name" :listDesc="req.recipe.storyline" :dateTime="req.created_at" :hostName="req.guest.first_name" :status="req.status" :currency="req.recipe.currency" :amount="req.recipe.amount" />
            </div>
            <div v-if="isRequests">
                <RequestCard v-for="(req, index) in guestRequests" :key="index" details_route_name="recipe-details" :user_id="req.guest.user_id" :routeId="req.recipe.food_id" user_route_name="public-profile" class="mt-2 mb-4" :imgUrl="req.recipe.images" torouteName='chef-pay' :listName="req.recipe.name" :listDesc="req.recipe.storyline" @handleReject="rejectListing(req)" :dateTime="req.created_at" :hostName="req.guest.fullname" :status="req.status" :currency="req.currency" :amount="req.amount" :bookingId="req.hire_id" />
            </div>
        </div>
    </b-container>
    <b-modal id="reject-action" centered title="Message to Guest" hide-footer>
        <div class="text-center">
            <form @submit.prevent="rejectHire">
                <b-form-group class="col-md-12 mt-2 mb-4" label-for="message">
                    <textarea style="height:auto !important;border:1px solid #ccc !important;" required v-model="chef_rejection_reason" rows="4" placeholder="Reason for cancelation/rejection" class="form-control"></textarea>
                </b-form-group>
                <button class="btn btn-warning btn-below">
                    {{sendbtnText}}
                    <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
                </button>
            </form>
        </div>

    </b-modal>
    <b-modal id="cancel-action" centered title="Message to Chef" hide-footer>
        <div class="text-center">
            <form @submit.prevent="cancelHire">
                <b-form-group class="col-md-12 mt-2 mb-4" label-for="message">
                    <textarea style="height:auto !important;border:1px solid #ccc !important;" required v-model="guest_rejection_reason" rows="4" placeholder="Reason for cancelation/rejection" class="form-control"></textarea>
                </b-form-group>
                <button class="btn btn-warning btn-below">
                    {{sendbtnText}}
                    <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
                </button>
            </form>
        </div>

    </b-modal>
    <b-modal id="approve-action" centered title="Respond to Guest" hide-footer>
        <form @submit.prevent="approveHire">
            <b-row>
                <b-form-group class="col-md-6 mt-2 mb-4" label-for="message">
                    <b-form-input class="bord-shadow" v-model="amount" min="0" step=".01" required type="number" placeholder="Price">
                    </b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6 mb-4" label-for="role">
                    <b-form-select v-model="currency" :options="currencies"></b-form-select>
                </b-form-group>
            </b-row>
            <button class="btn btn-warning btn-below">
                {{sendbtnText}}
                <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
            </button>
        </form>

    </b-modal>
    <b-modal id="message" hide-header centered title="Message" hide-footer>
        <div class="text-center">
            <p class="font-weight-bold mt-3 mb-3">Message</p>
            <p class="shadow-container custome-card">{{message}}</p>
        </div>

    </b-modal>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import RecipeSidebar from "@/components/RecipeSidebar.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import ApprovalCard from "@/components/L-ApprovalCard.vue";
import RequestCard from "@/components/HiringCard.vue";
import Activation from "@/components/Activation.vue";
import {
    ContentLoader
} from "vue-content-loader";

import axios from "axios";
import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl()
export default {
    name: 'manage-recipes',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        RecipeSidebar,
        ApprovalCard,
        RequestCard,
        ContentLoader,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Manage Recipes",
            subText: "Approve or Reject recipe hirings",
            fadedText: "Hosts",
            sendbtnText: "Send",
            isApprovals: true,
            isRequests: false,
            loading: false,
            amount: '',
            currency: null,
            currencies: [{
                    value: null,
                    text: 'Select currency'
                },
                {
                    value: "USD",
                    text: 'USD'
                },
            ],
            guestRequests: [],
            chefApprovals: [],
            hire_id: '',
            guest_rejection_reason: '',
            chef_rejection_reason: '',
            message: '',
            no_per_page: 10,
            page: 1,
            pagination: {},
        }
    },
    computed: {
        rows: function () {
            return this.pagination.total;
        },
    },
    mounted() {
        const tab = this.$route.query.tab
        if (tab === 'isRequests') {
            this.isApprovals = false
            this.isRequests = true
        }
        this.getChefRequests();
        this.getGuestRequests()
    },
    methods: {
        convert_date(datetime) {
            const date = new Date(datetime)
            return date
        },
        showGuestMessage(recipe) {
            this.$bvModal.show('message')
            this.message = recipe.guest_rejection_reason
        },
        showChefMessage(recipe) {
            this.$bvModal.show('message')
            this.message = recipe.chef_rejection_reason
        },
        handleRejectHire(request) {
            if (confirm("Do you really want to reject this request?")) {
                this.$bvModal.show('reject-action')
                this.hire_id = request.hire_id
            }
        },
        checkforPayment(request) {
            const req = request.status === "approved" ? 'yes' : 'no';
            return req
        },
        guestReject(request) {
            if (confirm("Do you really want to cancel this offer?")) {
                this.$bvModal.show('cancel-action')
                this.hire_id = request.hire_id
            }
        },
        handleApproveHire(request) {
            this.$bvModal.show('approve-action')
            this.hire_id = request.hire_id
        },
        showApprovals() {
            this.isApprovals = true;
            this.isRequests = false
        },
        showRequests() {
            this.isApprovals = false;
            this.isRequests = true

        },
        openMenu() {
            this.$root.$refs.A.openMenu('slidmenu')
        },
        hideSidemenu() {
            this.$root.$refs.A.hideSidemenu('slidmenu')
        },
        async getChefRequests(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/hirechef/me-as-chef`,
                    params: {
                        page: page,
                        no_per_page: this.no_per_page
                    },
                    method: "GET",
                })
                this.loading = false
                this.chefApprovals = resp.data.data
                this.pagination = resp.data.meta
            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async getGuestRequests(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/hirechef/me-as-guest`,
                    params: {
                        page: page,
                        no_per_page: this.no_per_page
                    },
                    method: "GET",
                })
                this.loading = false
                this.guestRequests = resp.data.data
            } catch (error) {
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async approveHire() {
            this.sendbtnText = "Sending..."
            const data = {
                hire_id: this.hire_id,
                status: 'approved',
                currency: this.currency,
                price: this.amount
            }
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/hirechef/responses`,
                    data: data,
                    method: "POST",
                })
                this.loading = false
                this.sendbtnText = "Send";
                this.$bvModal.hide('approve-action')
                this.getChefRequests();
                console.log(resp);

            } catch (error) {
                this.loading = false
                this.sendbtnText = "Send";
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async rejectHire() {
            this.sendbtnText = "Sending..."
            const data = {
                hire_id: this.hire_id,
                status: 'rejected',
                chef_rejection_reason: this.chef_rejection_reason
            }
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/hirechef/responses`,
                    data: data,
                    method: "POST",
                })
                this.loading = false;
                this.sendbtnText = "Send";
                this.$root.$refs.A.makeToast('success', resp.data.message)
                this.$bvModal.hide('reject-action')
                this.getChefRequests();
            } catch (error) {
                this.loading = false;
                this.sendbtnText = "Send";
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async cancelHire() {
            this.sendbtnText = "Sending..."
            const data = {
                hire_id: this.hire_id,
                status: 'cancelled',
                guest_rejection_reason: this.guest_rejection_reason
            }
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/hirechef/responses`,
                    data: data,
                    method: "POST",
                })
                this.loading = false;
                this.sendbtnText = "Send";
                this.$root.$refs.A.makeToast('success', resp.data.message)
                this.$bvModal.hide('cancel-action')
                this.getGuestRequests();
            } catch (error) {
                this.loading = false;
                this.sendbtnText = "Send";
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
    width: 95%;
}

.btn-culture {
    padding: 10px 60px !important;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        display: block;
        width: 100%;
        padding: 10px 15px !important;
        text-align: center;
    }
}

.bord-shadow,
.bord-shadow:focus,
.form-contol:focus {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%) !important;
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 8px) !important;

}

.form-control:focus {
    outline: none !important;
    // box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    margin: 20px auto
}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #F6F7F7;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }
}

.top-box {
    margin: 10px auto 20px auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #fff;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover,
.inner-header-box.active {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box:hover .b-icon.bi,
.inner-header-box.active .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.recipe-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.recipe-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.recipe-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center !important
}

.sidecard {
    box-shadow: 2px 6px 19px rgb(0 0 0 / 3%);
    border-radius: 4px;
    padding: 16px !important;
    border: none !important;
}

.slide-menu {
    position: absolute;
    z-index: 99;
    background: #fff;
    margin-left: -360px;
    width: 328%;
    top: 0px;
    padding-left: 16px;
    transition: all 0.4s ease-in-out;
}
</style>
